import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import axios from "axios";
import {defaultVariabls} from "../../../config";
import {setStore} from "trim-redux";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import List from "@material-ui/core/List/List";
import AddWriterButton from "./AddNarratorButton";
import Chip from "@material-ui/core/Chip/Chip";
import {Translate} from "../../../config/Translate";
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import TextField from "@material-ui/core/TextField/TextField";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Typography from "@material-ui/core/Typography/Typography";
import IconButton from "@material-ui/core/IconButton/IconButton";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import Button from "@material-ui/core/Button/Button";
import AddNarratorButton from "./AddNarratorButton";
class NarratorsChooser extends React.Component {
    constructor(props){
        super(props);
        this.timeout =  0;
    }
    classes = this.props.classes;
    state={
        defaults:[],
        result:this.props.input,
        loading: false,
        search:'',
        nothing_found:false,
        can_add:false,
    }
    componentDidMount(){
        this.setState({
            result:this.props.input,
        })
        this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            let {search} = this.state;
            await axios.get(`${defaultVariabls.url}/narrators/getAllForChooser${!!search ? "/"+search : ''}`, config)
                .then(response => {
                    this.setState({
                        defaults: response.data,
                        loading:false,
                        nothing_found:response.data.length === 0,
                        can_add:true,
                    })
                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    async reload(item){
        await this.handleClick(item)
        await this.loadData()
    }
    async handleClick(res){
        let {result} = this.state;
        let can_add = true;
        if(!!result){
            await result.map((item,index) => {
                if(item.id === res.id){
                    can_add = false;
                }
            });
        }else{
            result = [];
        }
        if(can_add === true){
            await result.push(res);
            await this.setState({
                result
            })
            await this.props.output(result)
        }

    }
    async handleDelete(res){
        let {result} = this.state;
        let i = -1;
        await result.map((item,index) => {
            if(item.id === res.id){
                i = index;
            }
        });
        if (i > -1) {
            await result.splice(i, 1); // 2nd parameter means remove one item only
        }
        await this.setState({
            result
        })
    }
    async handleChangeSearch(e){
        let text = e.target.value;
        await this.setState({
            search:text
        })
    }
    async handleSearch(){
        if(this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(async() => {
            await this.setState({
                loading:true
            });
            await this.loadData();
        }, 1000);

    }
    render(){
        let {result,loading,defaults,nothing_found,can_add} = this.state;
        return(
            <Grid container spacing={2}>
                {
                    !!result &&
                        <Grid item xs={12}>
                            {
                                result.map((item,index) => (
                                    <Chip
                                        key={index}
                                        label={item.name}
                                        style={{marginLeft:5,marginBottom:5}}
                                        onDelete={() => this.handleDelete(item)}
                                    />
                                ))
                            }

                        </Grid>
                }
                <Grid item xs={12}>
                    <TextField
                        label= {Translate.search}
                        fullWidth
                        size="small"
                        margin="normal"
                        variant="outlined"
                        name="search"
                        placeholder={Translate.narratorHelper}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {
                                        loading ?
                                            <CircularProgress size={22}/> :
                                            <IconButton size="small">
                                                <SearchRoundedIcon color="primary"/>
                                            </IconButton>
                                    }
                                </InputAdornment>
                            ),
                        }}
                        onKeyUp={() => this.handleSearch()}
                        onChange={this.handleChangeSearch.bind(this)}

                    />
                    {
                        loading ? null :
                            <List dense style={{maxHeight:240,overflowY:'auto'}}>
                                {
                                    !!defaults &&
                                    defaults.map((item,index) => (
                                        <ListItem
                                            key={index}
                                            button
                                            onClick={() => this.handleClick(item)}
                                        >
                                            <ListItemIcon>
                                                <ChevronLeftRoundedIcon />
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} />
                                            <ListItemSecondaryAction>
                                                <Button
                                                    size="small"
                                                    color="primary"
                                                    edge="end"
                                                    disableRipple
                                                    onClick={() => this.handleClick(item)}
                                                >
                                                    {Translate.choose}
                                                </Button>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))
                                }

                            </List>
                    }
                    {
                        !!nothing_found &&
                        <Typography>{Translate.noResultFound}</Typography>
                    }
                </Grid>
                {
                    !!can_add &&
                    <Grid item xs={12}>
                        <AddNarratorButton
                            reload={(item) => this.reload(item)}
                            search={this.state.search}
                        />
                    </Grid>
                }

            </Grid>
        )

    }
}
export default withStyles(Styles)(NarratorsChooser);